
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="closeAccountingCahs">
              <h2>Fechamento de caixa</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Data de abertura</label>
                <input
                  disabled
                  type="datetime"
                  class="form-control"
                  v-model="form.openedDate"
                />
              </div>

              <div class="form-group">
                <label>Fundo de troco</label>
                <input
                  disabled
                  type="number"
                  class="form-control"
                  v-model="form.moneyChange"
                  step="0.01"
                  value="0.00"
                  placeholder="0.00"
                />
              </div>
              <div class="form-group">
                <label>Total do sistema</label>
                <input
                  disabled
                  type="number"
                  class="form-control"
                  v-model="form.totalSystemSales"
                  step="0.01"
                  value="0.00"
                  placeholder="0.00"
                />
              </div>
              <h3>Labels</h3>
              <div class="row">
                <div
                  class="col-md-1"
                  v-for="(label, index) in form.labels"
                  :key="index"
                >
                  <LabelInfo :label="label" />
                </div>
              </div>
              <h3>Movimentos</h3>
              <Movements v-model="movements" :showForm="false" /><br />

              <h3>Total em sangria</h3>
              <CashMovement :cashMovement="cashRelief" />
              <br />
              <h3>Total em retirada</h3>
              <CashMovement :cashMovement="cashWithdraw" />
              <br />
              <h3>Total em reforço de caixa</h3>
              <CashMovement :cashMovement="cashReinforcement" />
              <br />
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Total declarado</label>
                    <input
                      type="number"
                      class="form-control"
                      v-model="form.totalDeclared"
                      step="0.01"
                      value="0.00"
                      placeholder="0.00"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Valor final</label>
                    <input
                      type="number"
                      step="0.01"
                      value="0.00"
                      placeholder="0.00"
                      class="form-control"
                      v-model="form.finalAmount"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Observação:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Digite uma obsrvação caso necessário"
                  v-model="form.description"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { format } from 'date-fns';
import Movements from '../../components/movements/Movments';
import LabelInfo from '../../components/labelInfo/LabelInfo';
import CashMovement from './components/cash-movement/CashMovement';

export default {
  name: 'CloseAccountingCash',
  components: {
    LabelInfo,
    Movements,
    CashMovement,
  },
  directives: { mask },
  data() {
    return {
      cashRelief: [],
      cashWithdraw: [],
      cashReinforcement: [],
      movements: [],
      form: {
        openedDate: '',
        totalSystemSales: '',
        moneyChange: '',
        finalAmount: '',
        description: '',
        totalDeclared: '',
        labels: [],
      },
    };
  },
  computed: {
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'close-accounting-cash',
        'CREATE',
      );
    },

    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'close-accounting-cash',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'close-accounting-cash',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'close-accounting-cash',
        'DELETE',
      );
    },
  },

  mounted() {
    this.listAccountingCash();
  },
  methods: {
    async listAccountingCash() {
      try {
        const accountingCashId = this.$route.params.accountingId;

        const { user, accountingHistory } = await this.$store.dispatch(
          'ACCOUNTING-CASH/ClosedAccountingInfo',
          accountingCashId,
        );
        this.form.openedDate = format(
          new Date(accountingHistory.openedDate),
          "dd-MM-yyyy'T'HH:mm:ss",
        );
        const formattedValue = value => {
          return (value / 100).toFixed(2);
        };

        const {
          cashRelief,
          cashWithdraw,
          cashReinforcement,
          labels,
          movements,
          totalSystemSales,
          finalAmount,
          description,
          totalDeclared,
        } = accountingHistory;

        this.form.totalSystemSales = formattedValue(totalSystemSales);
        this.form.moneyChange = formattedValue(accountingHistory.moneyChange);
        this.form.labels = labels;

        this.form.finalAmount = formattedValue(finalAmount);
        this.form.description = description;
        this.form.totalDeclared = formattedValue(totalDeclared);

        this.selectedUser = user;

        this.cashRelief = cashRelief;
        this.movements = movements;
        this.cashWithdraw = cashWithdraw;
        this.cashReinforcement = cashReinforcement;
      } catch (error) {
        this.$toasted.error('Não foi listar as informações do caixa');
      }
    },
  },
};
</script>